import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";

// Import supabase configuration
import supabase from '../config/supabase';
import Header from "../components/header/clientHeader";
import { Buffer } from "buffer";
import Skeleton from "react-loading-skeleton";
import { Oval } from "react-loader-spinner";
import moment from "moment";
import Calendly from "../components/calendly/calendly";
import { hotjar } from 'react-hotjar';
import mixpanel from 'mixpanel-browser';
import Login from "../components/loginModal/publicLogin";
import Snackbar from "@mui/material/Snackbar";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import {
    getClientNotification,
	updateClientProfiles
  } from "../redux/actions/actions";

// Import router from next
import { useNavigate } from "react-router-dom";

// testing token
// const token = 'Bearer '+'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjI1ODE1MjAxLCJqdGkiOiI5ZjBlZTlhYy1lM2ZhLTQ1MjEtOWJjYy1mNDUxYjQ4MWQwN2YiLCJ1c2VyX3V1aWQiOiJGRERCUzVWTEhYNUJVV0JRIn0._pUHaYDAX5DhxDoGj4sV17CVRqv91p5rh3P53dleKdI'; 

// live token
const token = 'Bearer '+'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjQ5MDg1NzE0LCJqdGkiOiJkYjhhMDI2NS03Nzk2LTRiZTYtYjdjZi1mM2NhY2YxYzlmNjciLCJ1c2VyX3V1aWQiOiJERUVETUJZRzVZQUJNUDdYIn0.q2St3KwElJAUq3gRAxBKM1mD88I2C80ccrw4bAi3CWI'; 

function CalendlyPage() {

    const navigate = useNavigate();
	const dispatch = useDispatch();

    const { clientNotification } = useSelector((state) => state.client);
	const [clientProfiles, setClientProfiles] = useState([]);
	const [profile, setProfile] = useState({});
	const [showLoader, setShowLoader] = useState(true);
	const [urlWithToken, setUrlWithToken] = useState("");
	const [meetingScheduled, setMeetingScheduled] = useState(false);

	const [isPublic, setIsPublic] = useState(false);
	const [toLogin, setToLogin] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const handleOpenModal = () => setOpenModal(true);
	const handleCloseModal = () => setOpenModal(false);
	const [justView, setJustView] = useState(true);
	const [showLogin, setShowLogin] = useState(true);
	const [boardId, setBoardId] = useState("");


	const style = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '35%',
		borderRadius: "5px",
		padding: "20px",
		'@media (max-width: 800px)': {
			width: '90%',
			padding: '10px'
		  },
	  };

	useEffect( async() => {
		document.title = "Schedule interview";
		mixpanel.init('de405b9420bcdeddec4d225dc80801ec'); 

		// Testing token
		// hotjar.initialize(2875931, 6);
		// live Token
		hotjar.initialize(2908411, 6);

		var url = new URL(window.location.href);
		var board_id = url.searchParams.get("board");
		var board_id = Buffer.from(board_id || "", "base64").toString("utf-8");
		var alreadyLoggedIn = localStorage.getItem("supabase.auth.token");
		if(board_id?.length>0) {
			setIsPublic(true);
			setJustView(false)
		} else {
			if(alreadyLoggedIn){
				setIsPublic(true);
				setJustView(false)
			} else {
				setIsPublic(false);
				setJustView(true);
			}
		}
		setBoardId(board_id);

		// Get profile id
		var profile_id = localStorage.getItem("clientBoardProfile");
		getProfileDetails(profile_id);

		var url = new URL(window.location.href);
		var clientInvitationId = url.searchParams.get("client");
		var client_invitation_id = Buffer.from(clientInvitationId || "", "base64").toString("utf-8");

		if(client_invitation_id){
			dispatch(getClientNotification(client_invitation_id))
		}
		localStorage.setItem("flag", true);

	}, []);

	const getClient = async(check) => {
		// get client invitation id
		var url = new URL(window.location.href);
		var clientInvitationId = url.searchParams.get("client");
		var client_invitation_id = Buffer.from(clientInvitationId || "", "base64").toString("utf-8");
		
		if(client_invitation_id)
		{
			if(check == "profiles"){
				var client = await getclientProfiles(client_invitation_id, "profiles");
				setClientProfiles(client.profiles);
				return {
					'profiles' : client.profiles,
					'clientId' : client_invitation_id,
					"clientEmail" : client.email,
				}
			}
			else{
				const url = await getclientProfiles(client_invitation_id, "url");
				return {
					"url" : url, "client_id" : client_invitation_id
				}
			}
		}
	}

	async function fetchDateTime(e) {
		// Get profile id
		setMeetingScheduled(true);
		setShowLoader(true);
		var profile_id = localStorage.getItem("clientBoardProfile");

		var client = await getClient("profiles");

		var profile = await getProfileDetails(profile_id);

		var cancel_url = '';
		var reschedule_url = '';
		var event_uuid = '';

		event_uuid = new URL(e.event.uri);
		event_uuid = event_uuid.pathname.split('/');
		event_uuid = event_uuid[2];

		const options = {
			method: 'GET',
			url: `${e.event.uri}/invitees`,
			headers: {
				'Content-Type': 'application/json',
				Authorization: token
			}
		  };
		  
		  axios.request(options).then(async function (response) {
			  console.log(response)
			console.log(response.data.collection[0].cancel_url);
			cancel_url = response.data.collection[0].cancel_url;
			
			console.log(response.data.collection[0].reschedule_url);
			reschedule_url = response.data.collection[0].reschedule_url;
			await axios.get(e.event.uri, { headers: { Authorization: token }})
				.then(function (response) {
					// handle success
					if(response.data.resource.start_time){
						var alreadyLoggedIn = localStorage.getItem("supabase.auth.token") || "";

						if(alreadyLoggedIn){

							updateMeetingTime(response.data.resource.start_time,response.data.resource.end_time, client.profiles,client.clientId,profile_id,profile, cancel_url, reschedule_url, event_uuid, response.data.resource.location.join_url)
						}
						else{
							var info = [];
							let details = JSON.parse(sessionStorage.getItem("publicInfo")) || "";
							info = details ? [...info, ...details] : [];

							let scheduled = {
								profileId : profile_id,
								scheduled : "true",
								startMeetingTime : response.data.resource.start_time,
								endMeetingTime : response.data.resource.end_time,
								meetingUrl: response.data.resource.location.join_url,
								cancel_url: cancel_url,
								reschedule_url: reschedule_url,
								event_uuid: event_uuid
							}

							info.push(scheduled);

							sessionStorage.setItem("publicInfo", JSON.stringify(info));
						}

						mixpanel.track('meetingScheduled', {
							'profileName': profile.full_name,
							"meetingTime" : response.data.resource.start_time,
							'clientEmail' : client.clientEmail,
						});
					}
				})
				.catch(function (error) {
				})
		  }).catch(function (error) {
			console.error(error);
		  });
	}

	function getRandomColor() {
        var letters = 'BCDEF'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++ ) {
            color += letters[Math.floor(Math.random() * letters.length)];
        }
        return color;
    }

	async function updateMeetingTime(startTime, endTime,tempClientProfiles,clientId,profileId,profile, cancel_url,  reschedule_url, event_uuid, meeting_url){
		tempClientProfiles.forEach((profile)=>{
			let color = getRandomColor();

			if(profile.id == profileId){
				profile.meetingTime = startTime;
				profile.endMeetingTime = endTime;
				profile.reschedule_url = reschedule_url;
				profile.cancel_url = cancel_url;
				profile.event_uuid = event_uuid;
				profile.meetingUrl = meeting_url;
				profile.bgColor = color;
			}
		})
		setClientProfiles(tempClientProfiles);
		setMeetingScheduled(true);

		dispatch(updateClientProfiles(tempClientProfiles, clientId))
		.then( async() => {
			
			let date  = new Date(startTime);
			var start = moment(date).format('MMMM Do, h:mm A') ;

			// End meeting time
			let endDate  = endTime && new Date(endTime);
			var end = endDate ? moment(endDate).format('h:mm A') : "";

			var name = profile.full_name ? profile.full_name.split(" ")[0] : "Akira";
			var message = "You have scheduled a meeting with " + name  + "'s recruitment manager; " + start + " - " + end;
			await insertNotifications(clientId,message);
		})
	}

	const insertNotifications = async(clientId,message) => {
		// localStorage.removeItem("flag");

		var profile_id = localStorage.getItem("clientBoardProfile");

		var { data, error } = await supabase
		.from("notifications")
		.select("*")
		.match({client: clientId, message: message,profileId:profile_id})

		if(data && data.length <= 0){
			let flag = localStorage.getItem("flag");
			if(flag == "true"){
				localStorage.removeItem("flag");
				var { data, error } = await supabase
				.from("notifications")
				.insert({client: clientId, message: message,profileId:profile_id})
		
				if(data && data.length){
					localStorage.setItem("showNumber",true);
					dispatch(getClientNotification(clientId))
					setShowLoader(false);
				}
			}else{
				dispatch(getClientNotification(clientId))
				setShowLoader(false);
			}
		}
	}

	const getclientProfiles = async(id, check) => {
		var { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ id: id });

      if (data && data.length) {
		  setUrlWithToken(data[0].url_with_token);
		  if(check == "profiles"){
			return {
				'profiles':data[0].profiles,
				'email': data[0].email,
			}
		  }
		  else{
			return data[0].url_with_token;
		  }
      }
	}


	async function getProfileDetails(profileId){
		var { data, error } = await supabase
        .from("all_profiles")
        .select("*")
        .match({ id: profileId });

		setShowLoader(false);

		if (data && data.length) {
			setProfile(data[0]);
			return data[0]
		}
	}
	

	async function toCandidates(){
		mixpanel.track('toOtherCandidates');

		if(urlWithToken){
			localStorage.removeItem("loggedIn");
			const url = urlWithToken.split("client")[1];
			navigate(`/client${url}`);
		}
		else{
			var url = new URL(window.location.href);
			var clientInvitationId = url.searchParams.get("client");
			
			if(clientInvitationId){
				localStorage.removeItem("loggedIn");
				let client = await getClient("url");
				url = client?.url.split("client")[1];
				navigate(`/client${url}`);
			}
			else{
				url = window.location.href.split("board")[1];
				navigate(`/client?id${url}`);
			}
		}
		
	} 

	return (
		<div className="w-full ">

			{/* Add header */}
			<Header loading={(value) => setShowLoader(value)} isPublic={isPublic} justView={justView} isLogin={!toLogin} handleOpenModal={handleOpenModal} isSignUp={() => setToLogin(!toLogin)} modal={openModal} showLogin={localStorage.getItem("supabase.auth.token") && !(localStorage.getItem("admin")) ? false : true} getClient={getClient}>
			
			{/* Login Modal */}
			<Modal
			open={openModal}
			disableAutoFocus={true}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			BackdropProps={{style: {backgroundColor: '#F8FDFFB2'}}}
			>
			<>
				<Header justView={true} modal={openModal} handleOpenModal={handleOpenModal} isLogin={toLogin} isSignUp={() => setToLogin(!toLogin)}> </Header>
				<Box sx={style}>
				{!toLogin && <h1 className="text-[26px] xl-2:text-[32px] leading-snug text-center font-bold mt-10">To maintain your engineer status, setup a password</h1>}
				<Login showLoader={(value) => setShowLoader(value)} showLogin={() => setShowLogin(false)} handleCloseModal={handleCloseModal} justView={() => setJustView(false)} profile={profile} isPublic={isPublic} boardId={boardId} isLogin={toLogin} isSignUp={(value) => setToLogin(value)} />
				</Box>
			</>
			</Modal>

			{showLoader && (
				<div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
				{/* Add backdrop */}
				
				<div className={`relative flex`}>
					<Oval
						color="white"
						secondaryColor="grey"
						height="40"
						width="60"
					/>
					<div className="flex items-center">Hold Tight-just getting this page ready.</div>
				</div>
				</div>
			)}
				<div className="md:hidden bg-[#F1F2F5] px-5 pt-5">
					{
						meetingScheduled ? <div className="flex">
								<p onClick={() => toCandidates()} className="col-span-2 text-white-1 p-2 rounded text-sm bg-pink-1">Back to candidates </p>
							</div>
						: 
					<div className="flex cursor-pointer " onClick={() => toCandidates()}>Back to board 
						{/* <svg className="ml-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12.172 12L9.343 9.172l1.414-1.415L15 12l-4.243 4.243-1.414-1.415z" fill="rgba(255, 73, 116, 1)"/></svg> */}
					</div>
					}
				</div>

				
				<div className="grid grid-cols-12 gap-0 sticky bg-[#F1F2F5] md:bg-white-1">
					<div className="col-span-12 md:col-span-8 md:pt-10 m-5 md:m-0">
						<Calendly onSchedule={fetchDateTime} />
					</div>
					
					<div className="hidden md:block md:col-span-4 bg-blue-7 relative">
						<div className="flex flex-col items-center justify-center pt-28">
							{/* Show image */}
							<img src="/calendly.png" className="" />
							{/* Show text */}
							{
								meetingScheduled ? <div className="font-bold text-center mx-5 xl:mx-8 xl-3:mx-16 text-3xl mt-16">
									Your meeting has been scheduled with {profile.full_name}'s recruiting manager
							</div> :
								<div className="font-bold text-center mx-5 xl:mx-8 xl-3:mx-16 text-3xl mt-16">
								{`Schedule a call with ${profile.full_name ? profile.full_name.split(" ")[0] : "Akira"}'s recruitment manager`}
							</div>
							}
							
							<div className="absolute -left-10 mb-28">
								<img src="/arrow.png" />
							</div>

							{/* Add card */}
							<div className={`grid grid-cols-12 gap-3 border-blue-4 border-2 shadow-calendlyProfileCard bg-white-1 px-7 py-5 mx-7 ${meetingScheduled ? "mt-16" : "mt-8"} mb-5 rounded-md`}>
								<div className="col-span-3 mt-3">
									{
										showLoader ? <div>
											<Skeleton height={90} width={90} />
										</div>
										// Render imgae
										: profile.emoji_url ? <div className="w-20 h-20 -ml-4 -mt-2">
											<img className="" src={profile.emoji_url} />
										</div> : (
											// Render placeholder
											<div className="w-16 h-16 bg-white-3 flex items-center">
											{/* Render text */}
											<div className="text-center w-full text-md font-text text-white-1 font-medium">
												{profile.full_name && profile.full_name[0].toUpperCase()}
											</div>
											</div>
										)
									}
								</div>
								
								<div className="col-span-9 grid grid-cols-12 gap-0">
									{
										showLoader ? <div className="col-span-12 ml-4">
										<div><Skeleton height={30} width={130} /></div>
										<div className="mt-2"><Skeleton height={20} width={130} /></div>
										<div className="mt-2"><Skeleton height={20} width={130} /></div>
										<div className="mt-2"><Skeleton height={25} width={130} /></div>
										
								</div>
								: <div className="col-span-12 grid grid-cols-12 gap-0">
									
									{/* Render name */}
									<div className="col-span-12 text-lg text-black-1 font-normal mb-2">
										{profile.full_name}
									</div>

									{/* Render location */}
									{profile.location ? (
									<div className="col-span-12 mb-2 text-sm font-light text-black-1 flex items-center">
										{/* Icon */}
										<img className="mr-1 h-4 " src="/location_icon2.svg" alt="Avatar" />

										{/* Text */}
										{profile.location} 
									</div>
									) : null}

									{/* Render timezone */}
									{profile.timezone ? <div className="col-span-12 text-sm font-light flex mb-4" >
										<svg className="mt-0.5 h-4 w-4 ml-0.5 fill-current text-black-1 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z"/></svg>
										{profile.timezone.split(" ")[0].replace(/[\(\)]/g, "")}
									</div>
									: null}

									{/* Show skills */}
									<div className="col-span-12 flex flex-wrap">
										{/* Render tags */}
										{(profile && profile.skill_level) ? profile.skill_level.length > 0 && profile.skill_level.length > 3
											? profile.skill_level.slice(0,3).map((element, index) => (
												<div
												key={index}
												className={`text-black-1 text-sm p-1 mr-2 rounded-sm border-blue-7 bg-white-1 border-2 font-text whitespace-nowrap`}
												>
												{element.skill}
												</div>
											))
											: profile.skill_level.map((element, index) => (
												<div
												key={index}
												className={`text-black-1 text-sm p-1 mr-2 rounded-sm border-blue-7 bg-white-1 border-2 font-text whitespace-nowrap`}
												>
												{element.skill}
												</div>
											))
											: null}
									</div>
								</div>
								}

								</div>
							</div>

							{
								meetingScheduled ? <div className="pb-10" onClick={() => toCandidates()}>
									<div className="font-semibold flex items-center text-white-1 mt-20 p-4 rounded cursor-pointer text-sm bg-pink-1">View other candidates </div> </div>
							 : 
							<div className="font-semibold flex text-pink-1 mt-20 cursor-pointer " onClick={() => toCandidates()}>View other candidates 
								<svg className="ml-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12.172 12L9.343 9.172l1.414-1.415L15 12l-4.243 4.243-1.414-1.415z" fill="rgba(255, 73, 116, 1)"/></svg>
							</div>
							}
							
						</div>
					</div>
				</div>
			</Header>
			
		</div>
	);
};

export default CalendlyPage;